// extracted by mini-css-extract-plugin
export default {"gridContainer":"AgenciesList_gridContainer__Jm6uW","fullHeight":"AgenciesList_fullHeight__b0vo2"};